import { buildApiUrl } from '../../../services/apiUrl';
import { authenticatedFetch } from '../../../lib/apiClient';
import type { AdminAppSessionContractResponse } from '../types/adminSession.api';

function getBridgeErrorMessage(response: AdminAppSessionContractResponse | null): string {
  return response?.error?.message ?? 'Session bridge unavailable.';
}

export async function fetchAdminAppSession(): Promise<AdminAppSessionContractResponse> {
  const response = await authenticatedFetch(buildApiUrl('/api/admin/session'), {
    method: 'GET',
  });
  const payload = (await response.json()) as AdminAppSessionContractResponse;

  if (!response.ok || !payload.success) {
    throw new Error(getBridgeErrorMessage(payload ?? null));
  }

  return payload;
}